module.exports = __webpack_public_path__ + "static/img/dl-7.564a48d.png";


//////////////////
// WEBPACK FOOTER
// ./src/products/dl-7.png
// module id = Vazd
// module chunks = 0